var app_ajax = null;
(function ($) {

    app_ajax = function (_url, _template_name) {

        var self = this;
        self.url = _url;
        self.doing_ajax = false;
        self.template = wp.template(_template_name);
        self.current_template = null;
        self.scrollPosition = 0;

        self.defaultTitle = $(document).prop('title');
        self.defaultLocation = window.location;
        self.bf = "forward";
        self.current_id = 0;
        self.timer = null;

        self.cache = [];


        self.do_ajax = function (id) {
            if (!undef(id) && !self.doing_ajax) {
                self.current_id = id;
                self.doing_ajax = true;
                self.reset_template();

                if (typeof self.cache[id] !== "undefined") {
                    self.ajax_complete(self.cache[id]);
                } else {
                    $.getJSON(self.url + "/" + id, self.ajax_complete);
                }

            }
        };

        self.ajax_complete = function (data) {

            self.doing_ajax = false;

            if (!$.isEmptyObject(data) && undef(data.code)) {

                self.cache[data.ID] = data;

                self.bf = "backward";

                self.scrollPosition = $(window).scrollTop();
                         

                self.current_template = $('<div/>', {
                    class: 'mustache-single-apartment-wrapper',
                    html: self.get_template(data)
                });
                
                //$("body").css({"height":$("body").outerHeight()});   

                self.current_template.find("a.sa-close-btn").on("click", self.close);

                
                $("body").wrapInner('<div class="as-hide">');
                $("body .as-hide").fadeOut(500,function(){
                $('html, body').stop().animate({ 
                    scrollTop: 0
                }, 0); 
                    $("body").addClass("as-is-open");
                    $("body").append(self.current_template); 
                }); 

                self.changeUrl(data.ID, data.title, data.permalink);
 
                    

            }

        };

        self.close = function (event) {
            event.stopImmediatePropagation();
            window.history.back();
        };

        self.changeUrl = function (id, page, url) {
            if (typeof (history.pushState) !== "undefined") {
                var obj = {Page: page, Url: url};
                history.pushState({"id": id}, page, url);
                $(document).prop('title', page);
                $(window).on('popstate', self.history);
            } else {
                console.log("cant change url... old browser");
            }

        };

        self.get_template = function (data) {
            return self.template(data);
        };

        self.reset_template = function () {

            if (self.current_template !== null) {
                $('body .as-hide > div:first').unwrap();
                $("body").removeClass("as-is-open");
                self.current_template.remove();
            }

            self.current_template = null;
        };

        self.history = function (event) {
            event.preventDefault();
            if (typeof event === 'object' && typeof event.type !== "undefined" && event.type === "popstate") {
                switch (self.bf) {
                    case "forward":
                        self.do_ajax(self.current_id);
                        break;
                    case "backward":
                        self.close_template(event);
                        break;
                }
            }
        };

        self.close_template = function (event) {

            self.current_template.fadeOut(500,function(){
                
                self.bf = "forward";
                $(document).prop('title', self.defaultTitle);
                self.changeUrl(1, self.defaultTitle, self.defaultLocation);
                $("body").removeClass("as-is-open as-closing");
                self.reset_template();
                
                $('html, body').stop().animate({
                    scrollTop: self.scrollPosition
                }, 0);  
                
                
            });
//            $("body").addClass("as-closing");  
////            $('html, body').stop().animate({
////                scrollTop: self.scrollPosition
////            }, 1000); 
//
//            if (self.timer !== null)
//                clearTimeout(self.timer);
//
//            self.timer = setTimeout(function () {
//                
//            }, 1000);  

        };

        return self;
    };

})(jQuery, window, document);